<ng-container *ngIf="model != null">
  <sc-flex stretchContent>
    <ng-container *ngFor="let column of model.columns; let i = index">
      <sc-content-spacer *ngIf="i > 0"></sc-content-spacer>
      <sc-flex-fitting-content>
        <sc-flex vertical stretchContent>
          <ng-container *ngFor="let option of column.options; let i = index">
            <ng-container *ngIf="showInternalTransportOptions || option.onlyInternal !== true">
              <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
              <app-transport-option-entry [option]="option" [model]="model"
                [showInternalTransportOptions]="showInternalTransportOptions" [showDriverHints]="showDriverHints"></app-transport-option-entry>
            </ng-container>
          </ng-container>
        </sc-flex>
      </sc-flex-fitting-content>
    </ng-container>
  </sc-flex>
  <ng-container *ngIf="!model.readOnly">
    <ng-container *ngFor="let message of model.messages">
      <sc-hint-legacy [dictionaryKey]="message" type="error">
      </sc-hint-legacy>
    </ng-container>
  </ng-container>
</ng-container>
